import { useQuery } from '@apollo/client'

import { GetCreateProductModalDocument } from '@/graphql/purchase-plus/generated/getCreateProductModal.generated'
import { PURCHASE_PLUS_GRAPHQL_API } from '@/modules/shared/constants'
import { checkNetworkStatus } from '@/modules/shared/utils/checkNetworkStatus'

interface UseGetCreateProductModalProps {
  productId: number
  skip?: boolean
}

export const useGetCreateProductModal = ({ productId, skip }: UseGetCreateProductModalProps) => {
  const { data, networkStatus, error, refetch } = useQuery(GetCreateProductModalDocument, {
    variables: {
      id: Number(productId),
    },
    context: {
      uri: PURCHASE_PLUS_GRAPHQL_API,
    },
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'no-cache',
    skip,
  })

  const product = data?.product

  const loadingStates = checkNetworkStatus(networkStatus)

  return {
    error,
    product,
    loadingStates,
    refetch,
  }
}
